const breadCrumb = "Diário Digital - Unidades Didáticas";

const routes = [
  {
    path: "/unidades-didaticas",
    name: "unidades-didaticas",
    meta: {
      allowedPermissions: ["unidade_didatica_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrosDiario/UnidadesDidaticas/UnidadesDidaticasHome.vue"
      ),
  },
  {
    path: "/unidades-didaticas/novo",
    name: "unidades-didaticas-novo",
    meta: {
      allowedPermissions: ["unidade_didatica_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrosDiario/UnidadesDidaticas/UnidadesDidaticasCad.vue"
      ),
  },
  {
    path: "/unidades-didaticas/editar/:id",
    name: "unidades-didaticas-editar",
    meta: {
      allowedPermissions: ["unidade_didatica_update"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrosDiario/UnidadesDidaticas/UnidadesDidaticasEdit.vue"
      ),
  },
];

export default routes;
